export const faqData = [
  {
    id: 1,
    question: "What is a debt consolidation loan?",
    answer:
      "A loan that combines multiple debts into one, often with a lower EMI and better terms.",
  },
  {
    id: 2,
    question: "How can I calculate my EMI for a consolidated loan?",
    answer:
      "Use Minemi’s Debt Consolidation Calculator by entering your loan amount, interest rate, and tenure to get accurate EMI estimates.",
  },
  {
    id: 3,
    question: "Does consolidating debt hurt my credit score?",
    answer:
      "No, consolidating debt can improve your score over time with timely repayments, though initial inquiries may cause a slight dip.",
  },
  {
    id: 4,
    question: "What types of debts can I consolidate?",
    answer:
      "Credit cards, personal loans, education loans, and more can be consolidated, depending on the lender.",
  },
  {
    id: 5,
    question: "Can I consolidate secured and unsecured loans together?",
    answer:
      "Yes, depending on the lender’s terms, you can consolidate both secured and unsecured loans.",
  },
  {
    id: 6,
    question: "How does debt consolidation save money?",
    answer:
      "It reduces the interest rate on high-interest debts, leading to lower EMIs and total repayment amounts.",
  },
  {
    id: 7,
    question: "When is debt consolidation not recommended?",
    answer:
      "When the consolidated loan has a higher interest rate or when your existing debts are manageable.",
  },
];
